import { render, staticRenderFns } from "./ServiceDetailTabsMap.vue?vue&type=template&id=98725cca&scoped=true&"
import script from "./ServiceDetailTabsMap.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsMap.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsMap.vue?vue&type=style&index=0&id=98725cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98725cca",
  null
  
)

export default component.exports